export enum AaspTemplateFamily
 {
  CLM = 'CLASSROOMLM',
  COLLECTIONS = 'COLLECTIONS',
  DD = 'UNIVERSAL_DISCOVERY',
  DESTINY ='DESTINY',
  DASHBOARD = 'DASHBOARD'
}
export default AaspTemplateFamily;
